<template>
    <el-scrollbar wrap-class="post-to-box">
        <Loading v-if="loading" class="static" />
        <div class="select-top-box" v-if="!loading">
            <div class="line-box">
                <div class="label-line">
                    <label>Select creators</label>
                    <Checkbox :checked="clickAll" :label_text="`All(${totalCount})`"
                        :no_show_label="true" @click="clickAll = !clickAll" />
                </div>
                <div class="input-line">
                    <el-select filterable remote :remote-method="searchCreators" :loading="searchLoading"
                        :disabled="clickAll" placeholder="Search name" reserve-keyword :remote-show-suffix="true"
                        popper-class="storefront-creator-dropdown" @visible-change="onDropdownVisible">
                        <el-option v-for="item in searchResults" :key="item.id" :label="item.name"
                            v-show="!isPicked(item)" :value="item.id" @click="pickCreator(item)" class="creator-item">
                            <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
                            <span>{{ item.name }}</span>
                        </el-option>
                        <div v-if="loadingMore && !searchLoading" class="creator-loadmore">
                            <span class="spinner"></span>Loading...
                        </div>
                        <template #loading>
                            <div class="creator-loadmore">
                                <span class="spinner"></span>Loading...
                            </div>
                        </template>
                    </el-select>
                </div>
            </div>

            <div class="line-box">
                <div class="label-line">
                    <label>Select {{ type === 'all' ? 'groups' : 'tags' }}<tippy content="Select groups"><svg-icon
                                name="question" />
                        </tippy></label>
                </div>
                <div class="input-line">
                    <el-select filterable placeholder="Select" :disabled="clickAll">
                        <el-option v-for="(item, index) in groupList.every(e => e.pick) ? [] : groupList"
                            :key="item.value" :label="item.name" v-show="!item.pick" :value="item.id"
                            @click="pickGroup(item, true)" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="select-bottom-box"
            v-if="pickedCreators.length > 0 || groupList.some(item => item.pick)">
            <div class="shadow-box" v-if="clickAll"></div>
            <h3 class="title" v-loading="countLoading">Added ({{ displayCount }})</h3>
            <el-collapse v-model="activeNames">

                <el-collapse-item title="Individuals" name="1"
                    v-if="pickedCreators.length > 0 && type === 'all'">
                    <div class="add-line" v-for="(item, index) in pickedCreators" :key="index">
                        <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
                        <div class="name">
                            <p class="bold">{{ item.name }}</p>
                            <p>{{ item.email }}</p>
                        </div>
                        <svg-icon class="stop-svg" name="stop" @click="removeCreator(item)" />
                    </div>
                </el-collapse-item>

                <!-- 9338 New -->
                <el-collapse-item title="Individuals" name="1"
                    v-if="pickedCreators.length > 0 && type === 'tag'">
                    <Table :style="'--top: 0px'">
                        <template #head>
                            <tr>
                                <th><span>Creator</span></th>
                                <th><span>Creator tag</span></th>
                                <th><span><svg-icon class="stop-svg-2" name="stop" /></span></th>
                            </tr>
                        </template>
                        <template #body>
                            <tr v-for="(item, index) in pickedCreators" :key="index">
                                <td>{{ item.name }}</td>
                                <td class="tags-list-box">
                                    <Badage v-for="(tag, tagKey) in (item.tag_list ?? [])" :key="tagKey" :class="['tag-item-box']" :value="tag.tag" :show_tippy="true"></Badage>
                                    <div v-if="!item.tag_list || item.tag_list.length===0">---</div>
                                </td>
                                <td><svg-icon class="stop-svg" name="stop" @click="removeCreator(item)" /></td>
                            </tr>
                        </template>
                    </Table>
                </el-collapse-item>

                <el-collapse-item title="Tags" name="2" v-if="groupList.some(item => item.pick)">
                    <div class="add-line" v-for="(item, index) in groupList" :key="index" v-show="item.pick">
                        <i class="group-icon"><svg-icon name="users-2" /></i>
                        <div class="name">
                            <p>{{ item.name }}</p>
                        </div>
                        <el-button size="mimi" @click="checkGroupCreators(item)">
                            <svg-icon name="users" />
                            {{ item.creator_count }}
                        </el-button>
                        <svg-icon class="stop-svg" name="stop" @click="removeGroup(item)" />
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="btn-row" v-if="!loading">
            <el-button @click="emit('close')">Cancel</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </div>

    </el-scrollbar>

    <el-dialog title="Remove from recipients?" width="300" v-model="removeDialog" :show-close="false"
        @close="removeDialog = false" class="alert-dialog">
        <p>This creator or selected {{ type==='all'?'group':'tags' }} will not receive this curated item.</p>
        <div class="btn-row" style="padding-top: 24px;">
            <el-button @click="removeDialog = false;">Cancel</el-button>
            <el-button type="primary" @click="handleRemove()">Yes</el-button>
        </div>
    </el-dialog>

    <!-- group list dialog -->
    <el-dialog title="Tag Group" width="600" v-model="groupDialog" @close="groupDialog = false" class="group-dialog">
        <Search @onenter="searchGroupCreator" :placeholder_text="'Search name'"
            :disabled="openGroupListValue.length === 0" v-if="!dialog_loading" />
        <el-scrollbar>
            <Loading class="static" v-if="dialog_loading" />
            <div class="add-line" v-for="(item, index) in openGroupListValue" :key="index">
                <figure><img :src="item.avatar ? item.avatar : UserImg" /></figure>
                <div class="name">
                    <p>{{ item.name }}</p>
                    <p>{{ item.email }}</p>
                </div>
            </div>
        </el-scrollbar>
    </el-dialog>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance, computed, nextTick } from 'vue';
import { ElButton, ElSelect, ElOption, ElCollapse, ElCollapseItem, ElScrollbar, ElDialog } from 'element-plus';
import Checkbox from '@/components/ui/Checkbox.vue';
import UserImg from '@/assets/images/user.png';
import Loading from '@/components/ui/Loading.vue';
import Search from '@/components/ui/Search.vue';
import Table from '@/components/ui/Table.vue';
import Badage from '@/components/ui/Badage.vue';

const props = defineProps({
    creators: {
        type: Array,
        required: true
    },
    group: {
        type: Array,
        required: true
    },
    click_all: {
        type: Array,
        required: true
    },
    list: {
        type: Object,
        required: true
    },
    type: {
        type: String,
        default: 'all' //all or tag
    }
});
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const emit = defineEmits(['close']);
const clickAll = ref(true);
const removeDialog = ref(false);
const groupDialog = ref(false);
const openGroupListValue = ref([]);
const openGroupListValueOrgin = ref([]);
const groupList = ref([]);
const pickedCreators = ref([]); //selected creators
const searchResults = ref([]); //paginated dropdown options returned from the ajax search
const searchLoading = ref(false); //first-page / search loading (bound to el-select)
const loadingMore = ref(false); //a request (first page or next page) is in flight
const keyword = ref(''); //current search keyword
const currentPage = ref(0); //last loaded page
const lastPage = ref(1); //total page count of the current query
const totalCount = ref(0); //total number of creators (when no keyword), used for All(N)
let searchTimer = null;
let searchSeq = 0;
let loadedKeyword = null; //keyword whose first page has been requested (null = nothing yet)

const handleRemoveValue = ref({
    type: 1,//1:creator,2:group
    item: {}
})

const loading = ref(false);
const dialog_loading = ref(false);
const count = ref(0);
const activeNames = ref(['1', '2']);
const countLoading=ref(false);
//when "All" is selected show the full creator count, otherwise the unique picked count
const displayCount = computed(() => (clickAll.value ? totalCount.value : count.value));
//+++++++++++++++++++++++++++++++++++++
// Methods
//+++++++++++++++++++++++++++++++++++++
//saved recipients only carry recipient_id, while search results also have id (=== recipient_id)
const creatorKey = (val) => val.recipient_id ?? val.id;

const isPicked = (val) => {
    return pickedCreators.value.some((item) => creatorKey(item) === creatorKey(val));
};

//fetch a page of creators via /storefront-curation/get-creator-list?name=xxx&page=x (50 per page)
//reset = true  -> first page of a new query (replaces the list)
//reset = false -> next page appended to the list (infinite scroll)
const fetchCreators = async (reset) => {
    //for "load more": skip if already loading or no more pages
    if (!reset && (loadingMore.value || currentPage.value >= lastPage.value)) return;
    const seq = ++searchSeq;
    const page = reset ? 1 : currentPage.value + 1;
    loadingMore.value = true;
    if (reset) {
        searchLoading.value = true;
        loadedKeyword = keyword.value; //mark before awaiting so a focus/click can't trigger a duplicate
    }
    try {
        const params = { page };
        if (keyword.value) params.name = keyword.value;
        const response = await ajax.get('/storefront-curation/get-creator-list', { params });
        //only apply the latest request's result to avoid out-of-order responses
        if (seq !== searchSeq) return;
        const data = response.data.data ?? {};
        const list = (data.data ?? []).map((e) => ({ ...e, name: e.name ? e.name : 'No Name People' }));
        searchResults.value = reset ? list : [...searchResults.value, ...list];
        currentPage.value = data.current_page ?? page;
        lastPage.value = data.last_page ?? page;
        //the unfiltered total is the full creator count, used for the All(N) label
        if (!keyword.value) totalCount.value = data.total ?? totalCount.value;
    } catch (error) {
        if (seq === searchSeq && reset) searchResults.value = [];
    } finally {
        if (seq === searchSeq) {
            loadingMore.value = false;
            searchLoading.value = false;
        }
    }
};

//debounced remote search; empty keyword loads the first page of all creators
const searchCreators = (query) => {
    if (clickAll.value) return;
    clearTimeout(searchTimer);
    const trimmed = (query ?? '').trim();
    //same keyword already requested -> skip (avoids the duplicate request on focus/click)
    if (trimmed === loadedKeyword) return;
    searchTimer = setTimeout(() => {
        keyword.value = trimmed;
        fetchCreators(true);
    }, 500);
};

//bind the dropdown scroll listener once it is rendered, for infinite scroll
const onDropdownVisible = async (visible) => {
    if (!visible) return;
    await nextTick();
    const wrap = document.querySelector('.storefront-creator-dropdown .el-select-dropdown__wrap');
    if (wrap && !wrap.dataset.loadmoreBound) {
        wrap.dataset.loadmoreBound = '1';
        wrap.addEventListener('scroll', onDropdownScroll);
    }
};

const onDropdownScroll = (event) => {
    if (clickAll.value) return;
    const el = event.target;
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= 2) {
        fetchCreators(false);
    }
};

const pickCreator = (val) => {
    if (!isPicked(val)) {
        pickedCreators.value.push({ ...val, name: val.name ? val.name : 'No Name People' });
    }
    countUser();
};

const pickGroup = (val, handle) => {
    groupList.value.forEach((item) => {
        if (item.id === val.id) {
            item.pick = handle;
        }
    });
    countUser();
};

const removeCreator = (val) => {
    handleRemoveValue.value = { type: 1, item: val };
    removeDialog.value = true;
};

const removeGroup = (val) => {
    handleRemoveValue.value = { type: 2, item: val };
    removeDialog.value = true;
};

const handleRemove = () => {
    if (handleRemoveValue.value.type === 1) {
        pickedCreators.value = pickedCreators.value.filter(item => creatorKey(item) !== creatorKey(handleRemoveValue.value.item));
        countUser();
    } else {
        pickGroup(handleRemoveValue.value.item, false);
    }
    handleRemoveValue.value.item = {};
    removeDialog.value = false;
};
const save = () => {
    let hadOne = pickedCreators.value.length > 0;
    let hadGroup = groupList.value.some(item => item.pick);
    if (clickAll.value || (!hadOne && !hadGroup)) {
        emit('close', { type: 'all', data: { creator: [], group: [], count: totalCount.value } });
    } else {
        emit('close', { type: 'pick', data: { creator: pickedCreators.value, group: groupList.value.filter(item => item.pick), count: count.value } });
    }

};

const startFunction = () => {
    clickAll.value = props.click_all;
    count.value = props.list.count ?? 0;
    getDropApi();
    fetchCreators(true); //preload the first page (also fills totalCount for the All(N) label)
};

const getDropApi = async () => {
    //seed the already-selected creators (the dropdown list is fetched via API on remote search)
    pickedCreators.value = props.creators.map(e => ({ ...e, name: e.name ? e.name : 'No Name People' }));
    groupList.value = props.list.groupList;
    groupList.value.forEach(e => {
        e.name = `${e.tag} (${e.creator_count})`;
        e.pick = props.group.some(gro => gro.id === e.id);
    })
    countUser();
};

//取得群組創作者
const checkGroupCreators = async (item) => {
    openGroupListValue.value = [];
    groupDialog.value = true;
    dialog_loading.value = true;
    const params = { tag_id: item.id };
    const response = await ajax.get(`/storefront-curation/get-tag-creator-list`, { params });
    const data = response.data.data;
    openGroupListValueOrgin.value = data;
    openGroupListValue.value = data;
    dialog_loading.value = false;
};

const searchGroupCreator = (keyword) => {
    openGroupListValue.value = openGroupListValueOrgin.value.filter(e =>
        e.name && e.name.toLowerCase().includes(keyword.toLowerCase())
    );
};

const countUser = async () => {
    countLoading.value = true;
    try {
        let params = {
            tag_ids: groupList.value.filter(item => item.pick).map(item => item.id),
            anchor_creator_ids: pickedCreators.value.map(item => creatorKey(item)),
        };
        const response = await ajax.get(`/storefront-curation/get-unique-creator-count`, { params });
        count.value = response.data.data ? response.data.data : 0;
        countLoading.value = false;
    } catch (error) {
        count.value = 0;
        countLoading.value = false;
    }
};
//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(() => {
    startFunction();
});

</script>
<style lang="scss">
.post-to-box {
    position: relative;

    .el-scrollbar {
        max-height: 60vh;
    }

    .el-scrollbar__view {
        max-height: 60vh;
        padding-right: 16px;
    }

    .line-box {
        display: grid;

        .label-line {
            display: flex;
            align-items: center;
            margin: 16px 0;
            gap: 8px;

            label {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 8px;
                font: var(--medium-16);
                color: var(--text-primary);

                .svg-icon {
                    cursor: pointer;
                    width: 16px;
                    height: 16px;
                    fill: var(--text-default);
                }
            }

            .ui-checkbox {
                margin: 0;
                font: var(--medium-14);
                color: var(--text-primary);
            }
        }

        .input-line {
            display: grid;

            .el-select {
                width: 100%;
            }

        }
    }

    .select-top-box {
        border-top: solid 1px var(--border);
    }

    .select-bottom-box {
        border-top: solid 1px var(--border);
        margin-top: 32px;
        padding: 16px 0;
        position: relative;

        .shadow-box {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--black-100);
            opacity: .3;
            z-index: 1;
            width: 100%;
            height: 100%;
        }

        h3 {
            font: var(--medium-16);
            color: var(--text-primary);
        }

        .el-collapse {
            border: none;

            .el-collapse-item__header {
                font: var(--font);
                font-size: 12px;
                color: var(--text-primary);
            }


            .el-collapse-item__content {
                display: grid;
                gap: 8px;
            }
        }
    }

    .btn-row {
        position: sticky;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 8px 0 4px;
        background-color: var(--white);
        z-index: 2;
        width: 100%;
    }

}

.add-line {
    display: flex;
    align-items: center;
    gap: 8px;

    figure {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        overflow: hidden;
        border: solid 1px var(--border);

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .group-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: solid 1px var(--border);
        display: flex;
        align-items: center;
        justify-content: center;

        .svg-icon {
            width: 16px;
            height: 16px;
            fill: var(--Text-default);
        }
    }

    .name {
        flex: 1;

        p {
            &:first-child {
                font: var(--medium-12);
                color: var(--text-primary);
            }

            &:last-child {
                font-size: 12px;
                color: var(--text-secondary);
            }
        }
    }

    .el-button--mimi span {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .svg-icon {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .stop-svg {
        fill: var(--red);
    }

}

.ui-table {
    .svg-icon {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .stop-svg {
        fill: var(--red);
    }

    .stop-svg-2 {
        fill: var(--text-secondary);
    }

    .tags-list-box {
        display: flex;
        align-items: center;
        padding: 4px;
        gap: 6px;
        min-height: 33px;

        .my-badges-iden {
            display: flex;
            align-items: center;
            border-radius: 6px;

            span {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 120px;
            }
        }

    }
}

.group-dialog {
    .el-scrollbar__view {
        display: grid;
        gap: 8px;
    }

    .ui-search-input {
        .input {
            max-width: unset;
        }

        margin: 0 0 16px 0;
    }
}

.el-select-dropdown {
    .creator-item {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }

        figure {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: solid 1px var(--border);
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }
}

.alert-dialog{
    .btn-row {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}

.storefront-creator-dropdown {
    .creator-loadmore {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 8px;
        font-size: 12px;
        color: var(--text-secondary);

        .spinner {
            width: 14px;
            height: 14px;
            border: 2px solid var(--border);
            border-top-color: var(--text-secondary);
            border-radius: 50%;
            animation: storefront-loadmore-spin 0.6s linear infinite;
        }
    }
}

@keyframes storefront-loadmore-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>